import { render, staticRenderFns } from "./AtomPartner.vue?vue&type=template&id=0891b016&scoped=true&"
import script from "./AtomPartner.vue?vue&type=script&lang=js&"
export * from "./AtomPartner.vue?vue&type=script&lang=js&"
import style0 from "./AtomPartner.vue?vue&type=style&index=0&id=0891b016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0891b016",
  null
  
)

export default component.exports